import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../common.service";
import { ApiService } from "../../api.service";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-learning-camp-introduction',
  templateUrl: './learning-camp-introduction.component.html',
  styleUrls: ['./learning-camp-introduction.component.css']
})
export class LearningCampIntroductionComponent implements OnInit, AfterViewInit {
  @Input() onceValue: any;
  @Input() campName: string;
  @Input() version: string;
  @Input() campId: number;

  @Output() onCloseLearningCampIntroduction = new EventEmitter<any>();

  isClosePage: boolean = false; //是否关闭页面
  isShowCommonBtn: boolean = false; //关闭按钮文字判断
  assetsRoute: string = "../../../assets"; //静态资源地址
  isShowBottomBtn: boolean = false; //是否显示底部按钮

  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService,
              private cookieService: CookieService,
              private commonService: CommonService) {}

  ngOnInit() {
    this.commonService.getOnceIno(this.onceValue).then(result=>{
      this.isShowCommonBtn = result !== 1;
    })
  }

  ngAfterViewInit() {

  }

  //关闭学习旅程
  closeLearningCampIntroduction(){
    this.isClosePage = true;
    this.commonService.setOnceIno(this.onceValue).subscribe(()=>{
      setTimeout(()=>{
        this.onCloseLearningCampIntroduction.emit();
      },300);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-introduction/learning-camp-introduction.component.ts